import { applyMiddleware, combineReducers, createStore } from 'redux'
import thunk from 'redux-thunk'
import data from './data'
import user from './user'

const reducers = combineReducers({ data, user })

export default () => createStore(reducers, applyMiddleware(thunk))